// /src/components/SeoTags.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';

const SUPPORTED = ['uk','en','it','fr'];

function normalizePath(pathname) {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length && SUPPORTED.includes(parts[0].toLowerCase())) {
    return '/' + parts.slice(1).join('/');
  }
  return pathname === '/' ? '/' : '/' + parts.join('/');
}

function withLang(lang, pathname) {
  const tail = normalizePath(pathname).replace(/^\/+/, '');
  return `/${lang}/${tail}`.replace(/\/{2,}/g, '/');
}

export default function SeoTags() {
  const loc = useLocation();

  React.useEffect(() => {
    const { origin } = window.location;
    const pathname = loc.pathname || '/';
    const search   = loc.search || '';
    const hash     = ''; // canonical/alternate без hash

    // Текущий язык из URL
    const parts = pathname.split('/').filter(Boolean);
    const currentLang = (parts[0] && SUPPORTED.includes(parts[0].toLowerCase())) ? parts[0].toLowerCase() : 'uk';

    // Удаляем ТОЛЬКО ранее вставленные нами теги
    Array.from(document.head.querySelectorAll('link[data-seo-inserted="true"]'))
      .forEach(n => n.parentNode && n.parentNode.removeChild(n));

    // Каноникал = текущий язык + путь
    const canonicalHref = origin + withLang(currentLang, pathname) + search + hash;

    // Вставляем canonical
    const canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', canonicalHref);
    canonical.setAttribute('data-seo-inserted', 'true');
    document.head.appendChild(canonical);

    // Alternate для всех языков
    SUPPORTED.forEach(lng => {
      const alt = document.createElement('link');
      alt.setAttribute('rel', 'alternate');
      alt.setAttribute('hreflang', lng);
      alt.setAttribute('href', origin + withLang(lng, pathname) + search);
      alt.setAttribute('data-seo-inserted', 'true');
      document.head.appendChild(alt);
    });

    // x-default → дефолтная (uk)
    const xdef = document.createElement('link');
    xdef.setAttribute('rel', 'alternate');
    xdef.setAttribute('hreflang', 'x-default');
    xdef.setAttribute('href', origin + withLang('uk', pathname) + search);
    xdef.setAttribute('data-seo-inserted', 'true');
    document.head.appendChild(xdef);
  }, [loc.pathname, loc.search]);

  return null;
}
